



















































import { Component, Mixins } from 'vue-property-decorator'

import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'

import { mock } from '@/tools'
import { security } from '@/store/modules/security'
import { UserLoginRequest } from '@/api'
import { LoginValidations } from '@/mixins/forms/LoginValidations'

@Component
class LoginView extends Mixins<LoginValidations>(LoginValidations) {
  securityModule = security.context(this.$store)

  icons = {
    mdiEyeOutline,
    mdiEyeOffOutline,
  }

  form: UserLoginRequest = {
    login: null,
    password: null,
  }

  isPasswordVisible = false

  get publicPath() {
    return process.env.PUBLIC_PATH
  }

  async login() {
    try {
      await this.securityModule.actions.login(this.form)
      const redirect = sessionStorage.getItem('redirect')
      const nextRoute =
        redirect && this.securityModule.getters.isUserRoleHolderOrFictiveOrChild ? redirect : { name: 'main' }

      await this.$router.push(nextRoute)
      sessionStorage.removeItem('redirect')
    } catch (error) {
      mock(error)
    }
  }
}

export default LoginView
